import * as React from 'react';

import { FormattedViewModel, TextType } from 'models';

import { SectionHTMLText, SectionPlainText } from './section-text';

interface RenderBodyHelperProps {
  propertyInfoBody: FormattedViewModel;
  hasBodyAndSections?: boolean;
}

export const SectionBody = ({ propertyInfoBody, hasBodyAndSections }: RenderBodyHelperProps) => {
  if (!propertyInfoBody) {
    return null;
  }

  return (
    <div className="section-body">
      {propertyInfoBody.textType === TextType.HTML_TEXT && (
        <SectionHTMLText description={propertyInfoBody.description} topPadding={!hasBodyAndSections && 'all-t-padding-three'} />
      )}
      {propertyInfoBody.textType === TextType.PLAIN_TEXT && (
        <SectionPlainText description={propertyInfoBody.description} topPadding={!hasBodyAndSections && 'all-t-padding-three'} />
      )}
    </div>
  );
};

SectionBody.displayName = 'SectionBody';
